export enum VisitStatus2 {
  FUTURE = 'Future',
  SCHEDULED = 'scheduled',
  MISSED = 'missed',
  CLINIC = 'clinic',
  PENDING = 'pending',
  SIGNED = 'signed',
  FILED = 'filed',
}
